import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import { pushFormSubmit } from '../utils/gtm';

const RequestBrochurePage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    phone: ''
  });
  const [imageUrl, setImageUrl] = useState<string>('');

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

  useEffect(() => {
    // Fetch all images and find the one with matching filename
    fetch(`${API_URL}/api/images`)
      .then(res => res.json())
      .then(data => {
        const targetImage = data.images?.find((img: any) => 
          img.filename.toLowerCase() === 'request-a-brochure-2.jpg' ||
          img.storedName?.toLowerCase().includes('request-a-brochure-2')
        );
        if (targetImage) {
          setImageUrl(`${API_URL}${targetImage.url}`);
        }
      })
      .catch(err => console.error('Error loading image:', err));
  }, [API_URL]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      const response = await fetch(`${API_URL}/api/brochure-requests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Failed to submit brochure request');
      }

      const data = await response.json();
      console.log('Brochure request submitted:', data);

      pushFormSubmit({ formId: 'brochure_request', formName: 'Request Brochure' });
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: ''
      });
      
      alert('Thank you! Your brochure request has been submitted. We will send you information about our medical alert systems soon.');
    } catch (error) {
      console.error('Error submitting brochure request:', error);
      alert('There was an error submitting your request. Please try again or call us at 1-877-579-9862.');
    }
  };

  const states = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 
    'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 
    'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 
    'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 
    'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 
    'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 
    'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 
    'Wisconsin', 'Wyoming'
  ];

  return (
    <div className="brochure-page">
      <section className="brochure-content">
        <div className="container">
          <div className="brochure-header">
            <h1 className="brochure-main-title">Request Your Alert1 Medical Alert Brochure</h1>
            <h2 className="brochure-subtitle">Want to know more about Alert1 Medical Alert Systems?</h2>
          </div>
          
          <div className="brochure-grid">
            <div className="brochure-form-section">
              <p className="brochure-intro">
                Please provide us with your name, address, and contact information using 
                this form and we will be happy to send you a free brochure 
                explaining the benefits and features of our products and services.
              </p>

              <h3>Request a FREE Brochure</h3>

              <form onSubmit={handleSubmit} className="brochure-form">
                <div className="form-row">
                  <label htmlFor="name">Your Name:</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-row">
                  <label htmlFor="email">Your Email:</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-row">
                  <label htmlFor="address">Address:</label>
                  <input
                    type="text"
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-row">
                  <label htmlFor="city">City:</label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-row">
                  <label htmlFor="state">State:</label>
                  <select
                    id="state"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Please Select...</option>
                    {states.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-row">
                  <label htmlFor="zipCode">Zip Code:</label>
                  <input
                    type="text"
                    id="zipCode"
                    name="zipCode"
                    value={formData.zipCode}
                    onChange={handleChange}
                    pattern="[0-9]{5}"
                    required
                  />
                </div>

                <div className="form-row">
                  <label htmlFor="phone">Your Phone:</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-row">
                  <button type="submit" className="btn-request-brochure">
                    REQUEST BROCHURE
                  </button>
                </div>
              </form>
            </div>

            <div className="brochure-image-section">
              {imageUrl ? (
                <img 
                  src={imageUrl} 
                  alt="Happy senior couple outdoors"
                  className="brochure-couple-image"
                />
              ) : (
                <div className="image-placeholder">Loading image...</div>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RequestBrochurePage;

